import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b65005a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "access-denied"
}
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "modalWrapper"
}
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Access Denied")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "text"
}
const _hoisted_8 = {
  key: 1,
  class: "text"
}
const _hoisted_9 = {
  key: 2,
  class: "text"
}
const _hoisted_10 = {
  key: 3,
  class: "text"
}
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = { class: "button-controls" }

export function render(_ctx, _cache) {
  return (_ctx.modalOpened)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "fal fa-times close-icon",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.typeA)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " This page is currently being accessed by " + _toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName) + ". Please try again later. ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.typeB)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Another user is currently managing the authorised signatory or in Part B form. Please try again later. "))
                      : _createCommentVNode("", true),
                    (_ctx.typeC)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Another user is currently in Part B form. Please try again later "))
                      : _createCommentVNode("", true),
                    (!_ctx.typeA && !_ctx.typeB && !_ctx.typeC)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.formStatus?.updatingBy?.firstName ?? '') + " " + _toDisplayString(_ctx.formStatus?.updatingBy?.lastName ?? '') + " is presently accessing and answering the form. Access to this form is restricted until they exit or submit it. Please wait until the current session has ended. ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (_ctx.typeA)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-outline dark",
                            onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                          }, "Close"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-outline dark",
                            onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                          }, "OK"))
                    ])
                  ])
                ])
              ], 512)
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}